import React, { lazy } from 'react';

import { ROUTES } from 'consts';
import AnalyticsApartmentStatus from './Analytics/AnalyticsApartmentStatus';

const ApartmentsStatus_FP = lazy(
  () =>
    import(
      /* webpackChunkName: "apartmentsStatus_FP" */
      './ApartmentsStatus_FP'
    ),
);

const PlacementsStatus = lazy(
  () =>
    import(
      /* webpackChunkName: "placementsStatus" */
      './PlacementsStatus'
    ),
);

const ApartmentStatus = lazy(
  () =>
    import(
      /* webpackChunkName: "apartmentStatus" */
      './ApartmentStatus'
    ),
);

const ApartmentList = lazy(
  () =>
    import(
      /* webpackChunkName: "apartmentList" */
      './ApartmentList'
    ),
);

const ApartmentsDefects = lazy(
  () =>
    import(
      /* webpackChunkName: "apartmentsDefects" */
      './Defects/ApartmentsDefects'
    ),
);

const EngineeringDefects = lazy(
  () =>
    import(
      /* webpackChunkName: "engineeringDefects" */
      './Defects/EngineeringDefects'
    ),
);

const EngineeringNetStatus = lazy(
  () =>
    import(
      /* webpackChunkName: "engineeringNetStatus" */
      './EngineeringNetStatus'
    ),
);

const EngineeringCalls = lazy(
  () =>
    import(
      /* webpackChunkName: "engineeringCalls" */
      './Calls/EngineeringCalls'
    ),
);

const ApartmentsCalls = lazy(
  () =>
    import(
      /* webpackChunkName: "apartmentsCalls" */
      './Calls/ApartmentsCalls'
    ),
);

const MyCalls = lazy(
  () =>
    import(
      /* webpackChunkName: "myCalls" */
      './Calls/MyCalls'
    ),
);

const ApartmentsSetting = lazy(
  () =>
    import(
      /* webpackChunkName: "setting" */
      './Setting/ApartmentsSetting'
    ),
);

const EngineeringSetting = lazy(
  () =>
    import(
      /* webpackChunkName: "setting" */
      './Setting/EngineeringSetting'
    ),
);

const TimesheetApartments = lazy(
  () =>
    import(
      /* webpackChunkName: "timesheetApartments" */
      './Timesheet/TimesheetApartments'
    ),
);

const TimesheetEngNetworks = lazy(
  () =>
    import(
      /* webpackChunkName: "timesheetEngMetworks" */
      './Timesheet/TimesheetEngNetworks'
    ),
);

const StartSettlement = lazy(
  () =>
    import(
      /* webpackChunkName: "startSettlement" */
      './StartSettlement'
    ),
);

const TimeTableApartments = lazy(
  () =>
    import(
      /* webpackChunkName: "timeTable" */
      './TimeTable/TimeTableApartments'
    ),
);

const UploadingPlanApartments = lazy(
  () =>
    import(
      /* webpackChunkName: "uploadingPlanApartments" */
      './UploadingPlansApartments'
    ),
);

const Plan = lazy(
  () =>
    import(
      /* webpackChunkName: "plan" */
      './Plan'
    ),
);

const PlanEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "planEdit" */
      './Plan/PlanEdit'
    ),
);

const PlanDraft = lazy(
  () =>
    import(
      /* webpackChunkName: "planDraft" */
      './Plan/PlanDraft'
    ),
);

const PlanDrawer = lazy(
  () =>
    import(
      /* webpackChunkName: "planDrawer" */
      'features/PlanDrawer'
    ),
);

const PlanReadonly = lazy(
  () =>
    import(
      /* webpackChunkName: "planReadonly" */
      './Plan/PlanReadonly'
    ),
);

const PlanEngineeringDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "planEngineeringDetail" */
      './Plan/PlanEngineeringDetail'
    ),
);

const PlanAllChangeVersions = lazy(
  () =>
    import(
      /* webpackChunkName: "planAllChangeVersions" */
      './Plan/PlanAllChangeVersions'
    ),
);

const PlanChangeVersionDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "planChangeVersionDetail" */
      './Plan/PlanChangeVersionDetail'
    ),
);

const Documents = lazy(
  () =>
    import(
      /* webpackChunkName: "documents" */
      './Documents'
    ),
);

const ApartmentDeliverySchedule = lazy(
  () =>
    import(
      /* webpackChunkName: "apartmentDeliverySchedule" */
      './DeliverySchedule/ApartmentDeliverySchedule'
    ),
);

const DeliveryScheduleDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "deliveryScheduleDetail" */
      './DeliveryScheduleDetail'
    ),
);

// const AnalyticsContractor = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "analyticsContractor" */
//       './Analytics/AnalyticsContractor'
//     ),
// );

const AnalyticsTransferToSettlement = lazy(
  () =>
    import(
      /* webpackChunkName: "analyticsTransferToSettlement" */
      './Analytics/AnalyticsTransferToSettlement'
    ),
);

const AnalyticsRating = lazy(
  () =>
    import(
      /* webpackChunkName: "analyticsRating" */
      './Analytics/AnalyticsRating'
    ),
);

const AnalyticsReportingOvp = lazy(
  () =>
    import(
      /* webpackChunkName: "analyticsReportingOvp" */
      './Analytics/AnalyticsReportingOvp'
    ),
);

const Updates = lazy(
  () =>
    import(
      /* webpackChunkName: "updates" */
      './Updates'
    ),
);

export const Routes = [
  {
    path: '/feature-packages/apartmentsStatus',
    isProtected: true,
    component: ApartmentsStatus_FP,
  },
  {
    path: ROUTES.PLACEMENTS_STATUS.ROOT,
    isProtected: true,
    component: PlacementsStatus,
  },
  {
    path: ROUTES.APARTMENT_STATUS.ROOT,
    isProtected: true,
    component: ApartmentStatus,
  },
  {
    path: ROUTES.APARTMENT_LIST.ROOT,
    isProtected: true,
    component: ApartmentList,
  },
  {
    path: ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
    isProtected: true,
    component: () => <EngineeringCalls type='allocated' />,
  },
  {
    path: ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
    isProtected: true,
    component: () => <EngineeringCalls type='unallocated' />,
  },
  {
    path: ROUTES.CALLS.ENG_NETWORKS_MY_CALLS_ID,
    isProtected: true,
    component: MyCalls,
  },
  {
    path: ROUTES.CALLS.ENG_NETWORKS_MY_CALLS,
    isProtected: true,
    component: () => <EngineeringCalls type='mycalls' />,
  },
  {
    path: ROUTES.CALLS.APARTMENTS_ALLOCATED,
    isProtected: true,
    component: () => <ApartmentsCalls type='allocated' />,
  },
  {
    path: ROUTES.CALLS.APARTMENTS_UNALLOCATED,
    isProtected: true,
    component: () => <ApartmentsCalls type='unallocated' />,
  },
  {
    path: ROUTES.DEFECTS.APARTMENTS,
    isProtected: true,
    component: ApartmentsDefects,
  },
  {
    path: ROUTES.DEFECTS.ENG_NETWORKS,
    isProtected: true,
    component: EngineeringDefects,
  },
  {
    path: ROUTES.TIMESHEET.APARTMENTS,
    isProtected: true,
    component: TimesheetApartments,
  },
  {
    path: ROUTES.TIMESHEET.ENG_NETWORKS,
    isProtected: true,
    component: TimesheetEngNetworks,
  },
  {
    path: ROUTES.UPLOADING_PLAN.APARTMENTS,
    isProtected: true,
    component: UploadingPlanApartments,
  },
  {
    path: ROUTES.PLAN.PLACEMENTS,
    exact: true,
    isProtected: true,
    component: () => <Plan type='placements' />,
  },
  {
    path: ROUTES.PLAN.ENGINEERINGS,
    exact: true,
    isProtected: true,
    component: () => <Plan type='engineerings' />,
  },
  {
    path: ROUTES.PLAN.NEW_ENGINEERING,
    isProtected: true,
    component: PlanEngineeringDetail,
  },
  {
    path: ROUTES.PLAN.EDIT_ID,
    isProtected: true,
    component: PlanEdit,
  },
  {
    path: ROUTES.PLAN.DRAFT_ID,
    isProtected: true,
    component: PlanDraft,
  },
  {
    path: ROUTES.PLAN.READONLY,
    isProtected: true,
    component: PlanReadonly,
  },
  {
    path: ROUTES.PLAN.OVP,
    isProtected: true,
    component: PlanDrawer,
  },
  {
    path: ROUTES.PLAN.ALL_CHANGE_VERSIONS,
    isProtected: true,
    component: PlanAllChangeVersions,
  },
  {
    path: ROUTES.PLAN.CHANGE_VERSION_DETAIL,
    isProtected: true,
    component: PlanChangeVersionDetail,
  },
  {
    path: ROUTES.START_SETTLEMENT.ROOT,
    isProtected: true,
    component: StartSettlement,
  },
  {
    path: ROUTES.ENGINEERING.ROOT,
    isProtected: true,
    component: EngineeringNetStatus,
  },
  {
    path: ROUTES.TIMETABLE.APARTMENTS_MANAGERS,
    isProtected: true,
    component: () => <TimeTableApartments type='managers' />,
  },
  {
    path: ROUTES.TIMETABLE.APARTMENTS_PROJECTS,
    isProtected: true,
    component: () => <TimeTableApartments type='projects' />,
  },
  {
    path: ROUTES.SETTING.ENG_NET_BY_OBJECT,
    isProtected: true,
    component: () => <EngineeringSetting type='byObjects' />,
  },
  {
    path: ROUTES.SETTING.ENG_NET_BY_PROJECT,
    isProtected: true,
    component: () => <EngineeringSetting type='byProjects' />,
  },
  {
    path: ROUTES.SETTING.APARTMENTS,
    isProtected: true,
    component: ApartmentsSetting,
  },
  {
    path: ROUTES.DOCUMENTS.ROOT,
    isProtected: true,
    component: Documents,
  },
  // {
  //   path: ROUTES.ANALYTICS.CONTRACTOR,
  //   isProtected: true,
  //   component: AnalyticsContractor,
  // },
  {
    path: ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT,
    isProtected: true,
    component: AnalyticsTransferToSettlement,
  },
  {
    path: ROUTES.ANALYTICS.APARTMENT_STATUS,
    isProtected: true,
    component: AnalyticsApartmentStatus,
  },
  {
    path: ROUTES.ANALYTICS.RATING,
    isProtected: true,
    component: AnalyticsRating,
  },
  {
    path: ROUTES.ANALYTICS.REPORTING_OVP,
    isProtected: true,
    component: AnalyticsReportingOvp,
  },
  {
    path: ROUTES.UPDATES.ROOT,
    isProtected: true,
    component: Updates,
  },
  {
    path: ROUTES.DELIVERY_SCHEDULE.APARTMENTS_DETAIL_ID,
    isProtected: true,
    component: DeliveryScheduleDetail,
  },
  {
    path: ROUTES.DELIVERY_SCHEDULE.APARTMENTS,
    exact: true,
    isProtected: true,
    component: ApartmentDeliverySchedule,
  },
  /* {
    path: ROUTES.SYSTEM.NOT_ENOUGH_RIGHTS,
    isProtected: false,
    component: Page403,
  },
  /* {
    path: '*',
    isProtected: false,
    component: Page404,
  }, */
];
